/**
 * Indicador de carregamento na identidade Manafix (dourado / laranjinha).
 */
const Loading = ({ classes = null }) => {
  return (
    <div
      className={`flex w-fit flex-col items-center gap-3 text-primary ${classes ?? ""}`}
      role="status"
      aria-live="polite"
      aria-label="Carregando"
    >
      <div
        className="h-9 w-9 animate-mgsSpin rounded-full border-2 border-primary/25 border-t-primary"
        aria-hidden="true"
      />
      <div className="flex items-baseline font-medium tracking-wide text-laranjinha">
        <span>Carregando</span>
        <span className="animate-blink1">.</span>
        <span className="animate-blink2">.</span>
        <span className="animate-blink3">.</span>
      </div>
    </div>
  );
};

export default Loading;
